export interface SourceDoc {
  id: string
  label: string
  description: string
  pdf: string
  extracts?: string
}

// Source extracts imported as raw markdown at build time.
// Only organization (CO-*) sources are surfaced — branch / BTV / CVS
// material is authoring-only and never shown to crews (see CLAUDE.md HARD RULE #8).
// @ts-ignore — Vite ?raw imports are not typed by default
import co160Extracts from '../sources/CO-160-extracts.md?raw'
// @ts-ignore
import co1Extracts from '../sources/CO-1-extracts.md?raw'
// @ts-ignore
import co1325Extracts from '../sources/CO-13-25-extracts.md?raw'
// @ts-ignore
import co90Extracts from '../sources/CO-90-extracts.md?raw'
// @ts-ignore
import copgm26Extracts from '../sources/CO-pgm26-extracts.md?raw'
// @ts-ignore
import s329Extracts from '../sources/S-329-extracts.md?raw'

export const ORG_DOCS: SourceDoc[] = [
  {
    id: 'co-160',
    label: 'CO-160',
    description: 'Audio/Video Guidelines for Assemblies and Conventions',
    pdf: '/sources/CO-160_E.pdf',
    extracts: co160Extracts as string,
  },
  {
    id: 'co-1',
    label: 'CO-1',
    description: 'Convention Organization',
    pdf: '/sources/CO-1_E.pdf',
    extracts: co1Extracts as string,
  },
  {
    id: 'co-13-25',
    label: 'CO-13-25',
    description: 'Convention Department Overseer Guidelines',
    pdf: '/sources/CO-13-25_E.pdf',
    extracts: co1325Extracts as string,
  },
  {
    id: 'co-90',
    label: 'CO-90',
    description: 'Convention Volunteer Information',
    pdf: '/sources/CO-90_E.pdf',
    extracts: co90Extracts as string,
  },
  {
    id: 'co-pgm26',
    label: 'CO-pgm26',
    description: '2026 Convention Program',
    pdf: '/sources/CO-pgm26_E.pdf',
    extracts: copgm26Extracts as string,
  },
  {
    id: 's-329',
    label: 'S-329',
    description: 'Convention Volunteer Application',
    pdf: '/sources/S-329_E.pdf',
    extracts: s329Extracts as string,
  },
]

export const EQUIPMENT_DOCS: SourceDoc[] = [
  {
    id: 'ross-carbonite',
    label: 'Ross Carbonite — Operation Manual',
    description: 'Production switcher operation reference',
    pdf: '/sources/ross-carbonite-operation-manual.pdf',
  },
  {
    id: 'ross-carbonite-ultra-solo',
    label: 'Ross Carbonite Ultra Solo — Manual',
    description: 'Carbonite Ultra Solo (4844DR-110) full manual',
    pdf: '/sources/ross-carbonite-ultra-solo-manual-4844dr-110.pdf',
  },
  {
    id: 'ross-crossover-solo',
    label: 'Ross Crossover Solo — User Manual',
    description: 'Crossover Solo (4801DR-004) user manual',
    pdf: '/sources/ross-crossover-solo-user-manual-4801dr-004.pdf',
  },
  {
    id: 'ross-crossover-brochure',
    label: 'Ross Crossover — Brochure',
    description: 'Crossover product overview',
    pdf: '/sources/ross-crossover-brochure.pdf',
  },
  {
    id: 'saramonic-witalk9-se',
    label: 'Saramonic WiTalk9 SE — Manual',
    description: 'Wireless intercom system manual',
    pdf: '/sources/saramonic-witalk9-se-manual.pdf',
  },
  {
    id: 'telex-bp-1002-2002',
    label: 'Telex BP-1002 / BP-2002 — Manual',
    description: 'Wired intercom beltpack manual',
    pdf: '/sources/telex-bp-1002-2002-manual.pdf',
  },
]

export function findSourceById(id: string): SourceDoc | undefined {
  return ORG_DOCS.find((d) => d.id === id) ?? EQUIPMENT_DOCS.find((d) => d.id === id)
}

export const ALL_SOURCES: SourceDoc[] = [...ORG_DOCS, ...EQUIPMENT_DOCS]
